/**
 * manager-group-add.js
 */

import React from 'react';
import { 
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import DropMenu from 'components/drop-menu';
import AddGroupDialog from '../add-group-dialog';
import { ManagerGroupsContext } from './manager-groups-context';


export default function ManagerGroupAdd(props) {
  const { menuLabel } = props;
  const { t } = useTranslation('general');
  const { onCreateRequest } = React.useContext(ManagerGroupsContext);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  const [isRequestDialogOpen, setIsRequestDialogOpen] = React.useState(false);
  const [managerRole, setManagerRole] = React.useState();
  const roleName = Types.Role.getName(t, managerRole);
  const dialogText = {
    [Types.Role.SUPERVISOR]: <>Invite a supervisor to manage your account. The supervisor will have permission to view all of your training and deployment records, generate reports, reject and approve records and manage some aspects of your account such as billing.<br /><br />Note that the supervisor must be a PACKTRACK member. If they're not, then first ask them to sign up for an account at packtrackapp.com. Supervisor accounts are completely free.</>,
    [Types.Role.TRAINER]: <>Invite a trainer to manage your account. The trainer will have permission to view all of your training records, add comments, generate reports and create new events and exercises.<br /><br />Note that the trainer must be a PACKTRACK member. If they're not, then first ask them to sign up for an account at packtrackapp.com. Trainer accounts are completely free.</>
  };


  return (
    <>
      <DropMenu
        label={menuLabel}
        anchorOrigin={{
          vertical: isMobile ? 'top' : 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        items={[{
          key: 'supervisor',
          name: 'Invite Supervisor ...',
          icon: 'supervisor',
          onSelect: () => {
            setManagerRole(Types.Role.SUPERVISOR);
            setIsRequestDialogOpen(true);
          }
        }, {
          key: 'trainer',
          name: 'Invite Trainer ...',
          icon: 'trainer',
          onSelect: () => {
            setManagerRole(Types.Role.TRAINER);
            setIsRequestDialogOpen(true);
          }
        }]}
      />

      <AddGroupDialog
        title={`Request ${roleName}`}
        text={dialogText[managerRole]}
        inputLabel={`${roleName} Email`}
        isOpen={isRequestDialogOpen}
        onClose={() => setIsRequestDialogOpen(false)}
        onOk={async (email) => {
          const ret = await onCreateRequest(email, managerRole);
          if (ret === true) {
            setIsRequestDialogOpen(false);
          }
          return ret;
        }}
      />
    </>
  )
}